// RTK Query endpoint injection for the IAS OIDC login flow. Zero upstream edits —
// `Api.injectEndpoints` is the extension point Metabase provides. The endpoint
// mirrors `POST /api/oidc-auth` on the backend
// (see `metabase.ias.deployment-adapter.routes`).

import { Api } from "metabase/api/api";

interface OidcAuthRequest {
  oidcAccessToken: string;
}

interface OidcAuthResponse {
  id: string;
}

export const iasSessionApi = Api.injectEndpoints({
  endpoints: (builder) => ({
    createSessionWithOidcAuth: builder.mutation<
      OidcAuthResponse,
      OidcAuthRequest
    >({
      query: (body) => ({
        method: "POST",
        url: "/api/oidc-auth",
        body,
      }),
    }),
  }),
});

export const { useCreateSessionWithOidcAuthMutation } = iasSessionApi;
